import {
  Box,
  Grid,
  GridItem,
  Text,
  VStack,
  List,
  ListItem,
  Center,
  Icon,
  keyframes,
} from '@chakra-ui/react'
import {BsImage} from 'react-icons/bs'
import {BiSearch} from 'react-icons/bi'
import {AiOutlineStar} from 'react-icons/ai'
import {BsEmojiSmile} from 'react-icons/bs'

const slideUp = keyframes`
from { transform: translateY(20px); opacity: 0; }
to { transform: translateY(0); opacity: 1; }
`

const getIcon = (index: number) => {
  switch (index) {
    case 0:
      return BsImage
    case 1:
      return BiSearch
    case 2:
      return AiOutlineStar
    case 3:
      return BsEmojiSmile
    default:
      return BsImage
  }
}

const Section = ({
  section,
  style,
  index,
}: {
  section: any
  style: any
  index: number
}) => (
  <Box
    bg="white"
    p={6}
    borderRadius="lg"
    boxShadow="sm"
    height="100%"
    animation={`${slideUp} 0.5s ease-out forwards`}
    style={{
      opacity: 0,
      animationDelay: style?.animationDelay || '0s',
    }}>
    <VStack spacing={4}>
      <Center
        mt={'-54px'}
        bg="white"
        w={'64px'}
        h={'64px'}
        borderRadius={'12px'}
        border={'1px solid #E4E7EC'}
        boxShadow={'0px 1px 2px 0px rgba(16, 24, 40, 0.05)'}>
        <Icon
          as={(getIcon(index) as any) || <></>}
          boxSize={8}
          color="#101828"
          sx={{color: '#475467'}}
        />
      </Center>
      <Text fontWeight="600" fontSize="20px">
        {section?.title}
      </Text>
      <List spacing={2} width="100%">
        {section?.questions.map((question: any, index: number) => (
          <ListItem
            key={index}
            fontSize={'16px'}
            color={'#475467'}
            position="relative"
            paddingLeft="1.5em"
            _before={{
              content: '"•"',
              position: 'absolute',
              left: '0.5em',
            }}>
            {question}
          </ListItem>
        ))}
      </List>
    </VStack>
  </Box>
)

const Outline = ({currentContent}: {currentContent: any}) => {
  return (
    <Box p={4}>
      <Text fontSize="18px" textAlign="center" mb={12} color={'#007EF5'}>
        {currentContent?.data?.title.toUpperCase()}
      </Text>
      <Grid
        templateColumns={{
          base: '1fr',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(4, 1fr)',
        }}
        gap={6}>
        {currentContent?.data?.idea_questions.map(
          (section: any, index: number) => (
            <GridItem key={index}>
              <Section
                section={section}
                style={{animationDelay: `${index * 0.2}s`}}
                index={index}
              />
            </GridItem>
          ),
        )}
      </Grid>
    </Box>
  )
}

export default Outline
